import { TypeResponse } from 'gtd-ng-widget';

export class ProfileResponse extends TypeResponse {
  id: number;
  user_id: number;
  name: string;
  first_name: string;
  last_name: string;
  user: {
    id: number;
    name: string;
  };
  country: string;
  reference: string;
  address: string;
  phone: string;
  birthday: string;
  ms_teams: string;
  telegram: string;
  whatsapp: string;
  created_at: number;
  updated_at: number;
  status: string | number;
  email: string;
  description: string;
  api_key: string;
  api_url: string;
  api_provider: string;
  system_role: string;
  brand: { id: number; name: string };
}
